import { LiveVideoService } from '@rsos/live-video';

export const getVideoLink = (token: string) => {
  const searchParams = new URLSearchParams({
    // Either talkjs or ios messages do something bad with periods in search
    // params; so even though they're valid characters in that context, we
    // must urlencode them specially.
    token: encodeURIComponent(token).replace(/\./g, '%2E'),
  });

  return `${window.location.protocol}//${window.location.host}/live-video/?${searchParams.toString()}`;
};

export const postVideoLink = async (
  callerID = '',
  orgName = '',
): Promise<string> => {
  const api = new LiveVideoService(orgName, true);
  const { token } = await api.callerToken(callerID);

  return getVideoLink(token);
};
